import { render, staticRenderFns } from "./referee-manage.vue?vue&type=template&id=5ae16d48&scoped=true"
import script from "./referee-manage.vue?vue&type=script&lang=js"
export * from "./referee-manage.vue?vue&type=script&lang=js"
import style0 from "./referee-manage.vue?vue&type=style&index=0&id=5ae16d48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae16d48",
  null
  
)

export default component.exports